// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.

// To enable this functionality update the 'useCustomEvents' variable in
// the theme-globals.liquid file to 'true'.


// ============================================================
// CART - ITEM ADDED
// ============================================================

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

document.addEventListener("cart:item-added", function (evt) {

  console.log("Item added to the cart");

  console.log(evt.detail.product);

});


// ============================================================
// CART - UPDATED
// ============================================================

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {

  console.log("Cart updated");

  console.log(evt.detail.cart);

});


// ============================================================
// CART - ERROR
// ============================================================

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {

  console.log("Cart error");

  console.log(evt.detail.errorMessage);

});


// ============================================================
// QUICK CART - OPEN
// ============================================================

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {

  console.log("Quick cart opened");

  console.log(evt.detail.cart);

});


// ============================================================
// QUICK CART - CLOSE
// ============================================================

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {

  console.log("Quick cart closed");

});


// ============================================================
// PRODUCT VARIANT CHANGE
//
// FIX APPLE PAY / DYNAMIC CHECKOUT
//
// Lorsqu'une cliente change de taille, ce code met
// immédiatement à jour la variante utilisée par le formulaire
// Shopify et par le bouton Apple Pay.
//
// Cela évite qu'Apple Pay utilise la première variante
// du produit (par exemple la taille 36).
// ============================================================

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section.
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {

  console.log("Product variant changed");

  console.log(evt.detail.variant);


  // Vérifie que Stiletto nous a bien envoyé une variante.
  if (!evt.detail || !evt.detail.variant) {
    return;
  }


  var variant = evt.detail.variant;


  // Vérifie que la variante possède bien un ID Shopify.
  if (!variant.id) {
    return;
  }


  // Recherche tous les formulaires produits Shopify présents sur la page.
  var productForms = document.querySelectorAll(
    'form.shopify-product-form, form[action*="/cart/add"]'
  );


  productForms.forEach(function (form) {

    // --------------------------------------------------------
    // On ne touche qu'aux formulaires contenant
    // un bouton de paiement accéléré Shopify
    // (Apple Pay / Shop Pay / Google Pay / etc.).
    // --------------------------------------------------------

    var paymentButton = form.querySelector(
      '.shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout'
    );


    if (!paymentButton) {
      return;
    }


    // --------------------------------------------------------
    // Shopify ajoute normalement l'ID du produit
    // dans un champ appelé "product-id".
    //
    // Si ce champ existe, on vérifie qu'on modifie
    // bien le formulaire du produit concerné.
    // --------------------------------------------------------

    var productIdInput = form.querySelector(
      'input[name="product-id"]'
    );


    if (
      productIdInput &&
      variant.product_id &&
      String(productIdInput.value) !== String(variant.product_id)
    ) {

      return;

    }


    // --------------------------------------------------------
    // Recherche du champ "id".
    //
    // Shopify utilise ce champ pour savoir quelle
    // variante doit être achetée.
    // --------------------------------------------------------

    var variantInput = form.querySelector(
      'input[name="id"]'
    );


    // --------------------------------------------------------
    // Certaines anciennes versions de Stiletto
    // ne créent ou ne mettent à jour ce champ
    // qu'au moment de l'ajout au panier.
    //
    // Apple Pay peut être utilisé AVANT cet ajout.
    // On crée donc le champ immédiatement s'il manque.
    // --------------------------------------------------------

    if (!variantInput) {

      variantInput = document.createElement("input");

      variantInput.type = "hidden";

      variantInput.name = "id";

      form.appendChild(variantInput);

    }


    // --------------------------------------------------------
    // FORCE LA BONNE VARIANTE
    //
    // Exemple :
    // la cliente choisit taille 40 →
    // variant.id devient l'ID Shopify de la taille 40.
    // --------------------------------------------------------

    variantInput.value = variant.id;

    variantInput.setAttribute(
      "value",
      variant.id
    );


    // --------------------------------------------------------
    // Informe Shopify que le champ vient d'être modifié.
    // Cela permet au bouton de paiement accéléré
    // de récupérer la nouvelle variante.
    // --------------------------------------------------------

    variantInput.dispatchEvent(
      new Event("input", {
        bubbles: true
      })
    );


    variantInput.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );


    console.log(
      "Apple Pay variant synchronized:",
      variant.id
    );

  });

});


// ============================================================
// PRODUCT QUANTITY UPDATE
// ============================================================

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section.
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {

  console.log("Product quantity updated");

  console.log(evt.detail.quantity, evt.detail.variant);

});


// ============================================================
// QUICKVIEW
// ============================================================

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {

  console.log("Quickview loaded");

});